import {Button, Modal, NumberInput, Select, SegmentedControl, TextInput, Textarea, Space} from "@mantine/core";
import { FloppyDisk as IconDeviceFloppy } from "@phosphor-icons/react";
import {useCallback, useContext} from "react";
import {useNavigate} from "react-router";
import {Row, Col} from "../../../components/Flex/Flex";
import Label from "../../../components/Label/Label.tsx";
import MessageContext from "../../../context/MessageContext.tsx";
import {sanitizeTargetName} from "../../../utils/sanitize.ts";
import {difficulties, contractType, rewards} from "../data.js";
import api, {useUser} from '../../../utils/api.ts';
import ContractParser from "./ContractParser.tsx";


const optDifficulties = difficulties.map((d) => ({label: d, value: d}));
const optRewards = rewards.map(r => ({label: r, value: r}));

const optTypes = contractType.map(t => ({label: t, value: t}));


export default function EditContractModal({edit, setEdit, onHide, onSave, networks}) {
    const navigate = useNavigate();
    const {user} = useUser()
    const {error} = useContext(MessageContext);
    const save = (next='back') => {
        if(edit.name === '') {
            error('Fill the target name');
            return false;
        }
        if(edit.type === null) {
            error('Choose the contract type');
            return false;
        }
        if(edit.reward === null) {
            error('Choose the reward type');
            return false;
        }
        api.post('/bh/contract', edit).then(res => {
            if(next === 'back') {
                onSave(res.data.contract);
            } else if(next==='scan') {
                navigate('/bh/contract/'+res.data.contract.id, {state: {contract: res.data.contract}});
            }
        }).catch(err => {
            if(err.response.data.message) {
                error(err.response.data.message);
            } else {
                error('Save failed');
            }
            console.error(err);
        })
    }

    const footer = (
        <Row justify="between">
            <Button onClick={() => save('back')} leftSection={<IconDeviceFloppy size={16}/>}>Save & back</Button>
            <Button onClick={() => save('scan')} leftSection={<IconDeviceFloppy size={16}/>}>Save & scan</Button>
        </Row>
    )

    const correctName = useCallback(() => {
        setEdit(p => {
            return ({...p, name: sanitizeTargetName(p.name)})
        });
    }, []);

    const networkData = networks.map(n => ({value: n.id, label: n.name}));

    return (
        <Modal
            opened={true}
            onClose={onHide}
            title={edit.id === '' ? "Add new contract" : "Modify contract"}
            padding="sm"
        >
            <Row align="end" wrap={false}>
                <Col>
                    <Label htmlFor="target-name">Target Name</Label>
                    <TextInput id="target-name" value={edit.name} onChange={e => setEdit({...edit, name: e.target.value})} onBlur={correctName} disabled={edit.id !== ''} />
                </Col>
                <Col>
                    {edit.id === '' ? <ContractParser onData={update => setEdit(e => ({...e, ...update}))} networks={networks} disabled={user.subLevel===0} /> : null}
                </Col>
            </Row>
            <Space h="md" />
            <Row wrap={false}>
                <Col><Label>Expiration</Label>
                    <NumberInput style={{width: 80}} value={edit.expiration_y} onChange={v => setEdit({...edit, expiration_y: v})} min={0} placeholder="YY" hideControls/>
                </Col>
                <Col>
                    <Label>&nbsp;</Label>
                    <NumberInput style={{width: 80}} value={edit.expiration_d} onChange={v => setEdit({...edit, expiration_d: v})} min={0} max={365} placeholder="DDD" hideControls />
                </Col>
                <Col grow={1}>
                    <Label>Difficulty</Label>
                    <Select value={edit.difficulty} onChange={v => setEdit({...edit, difficulty: v})} data={optDifficulties} />
                </Col>
            </Row>
            <Space h="md" />
            <Row>
                <Col>
                    <Label>Type</Label>
                    <SegmentedControl className={edit.type === null ? 'p-invalid' : ''} value={edit.type} onChange={v => setEdit({...edit, type: v})} data={optTypes} />
                </Col>
            </Row>
            <Space h="md" />
            <Row>
                <Col>
                    <Label>Reward</Label>
                    <SegmentedControl className={edit.reward === null ? 'p-invalid' : ''} value={edit.reward} onChange={v => setEdit({...edit, reward: v})} data={optRewards} />
                </Col>
            </Row>
            <Space h="md" />
            <Row>
                <Col>
                    <Label>Guild Network</Label>
                    <Select data={networkData} value={edit.network} onChange={v => setEdit({...edit, network: v})} searchable />
                </Col>
            </Row>
            <Space h="md" />


            <Label>Notes</Label>
            <Textarea className="w-full" value={edit.notes} onChange={e => setEdit({...edit, notes: e.target.value})}/>
            <Space h="md" />
            {footer}
        </Modal>
    )
}
